import { createFileRoute, redirect } from "@tanstack/react-router";

/** /guias has no listing of its own — guides live in the Insights index. */
export const Route = createFileRoute("/guias/")({
  beforeLoad: () => {
    throw redirect({ to: "/insights", statusCode: 301 });
  },
});
